export default "__VITE_ASSET__J3zE1wIU__"